import React from 'react';
import styles from './ManageStartupPage.module.css';

const EditParticipantPopup = ({
  participant, // entry.e or entry.r
  identifier, // entry.identifier
  startupName, // entry.startup_name (full list)
  onClose,
  onSubmit,
  updateField,
  updateListField,
  addListItem,
  removeListItem,
  updateStartupListField,
  addStartupListItem,
  removeStartupListItem,
  onDelete, // <-- new prop
}) => {
  if (!participant) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popup}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h3>Edit Participant Details</h3>
          <button
            className={styles.deleteButton}
            style={{
              fontSize: '0.8em',
              background: '#d32f2f',
              border: 'none',
              color: '#ffffff',
              cursor: 'pointer',
              padding: '0.5em 1em',
            }}
            title="Delete Startup"
            onClick={onDelete}
          >
            Delete Startup
          </button>
        </div>

        <label>Identifier:</label>
        <div>{identifier}</div>

        <div>
          <label>Startup Name:</label>
          {startupName?.map((item, idx) => (
            <div key={`startup_name-${idx}`} className={styles.listItemRow}>
              <input
                className={styles.input}
                type="text"
                value={item}
                onChange={(e) => updateStartupListField(idx, e.target.value)}
              />
              <button
                className={styles.removeButton}
                onClick={() => removeStartupListItem(idx)}
              >
                🗑️
              </button>
            </div>
          ))}
          <button className={styles.addButton} onClick={addStartupListItem}>
            + Add Startup Name
          </button>
        </div>

        <div>
          <label>Full Name:</label>
          {participant.full_name?.map((item, idx) => (
            <div key={`full_name-${idx}`} className={styles.listItemRow}>
              <input
                className={styles.input}
                type="text"
                value={item}
                onChange={(e) =>
                  updateListField('full_name', idx, e.target.value)
                }
              />
              <button
                className={styles.removeButton}
                onClick={() => removeListItem('full_name', idx)}
              >
                🗑️
              </button>
            </div>
          ))}
          <button
            className={styles.addButton}
            onClick={() => addListItem('full_name')}
          >
            + Add Full Name
          </button>
        </div>

        <div>
          <label>Code:</label>
          {participant.code?.map((item, idx) => (
            <div key={`code-${idx}`} className={styles.listItemRow}>
              <input
                className={styles.input}
                type="text"
                value={item}
                onChange={(e) => updateListField('code', idx, e.target.value)}
              />
              <button
                className={styles.removeButton}
                onClick={() => removeListItem('code', idx)}
              >
                🗑️
              </button>
            </div>
          ))}
          <button
            className={styles.addButton}
            onClick={() => addListItem('code')}
          >
            + Add Code
          </button>
        </div>

        <div className={styles.buttonGroup}>
          <button className={styles.button} onClick={onSubmit}>
            Submit
          </button>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditParticipantPopup;
